import {WritingPractice} from "./writingPractice.mjs";
import {Table} from "./table.mjs";
import {Color} from "./color.mjs";
import {Text} from "./text.mjs";
import {Emphasis} from "./emphasis.mjs";
import {HiddenInput} from "./hiddenInput.mjs";
import {LineFeed} from "./lineFeed.mjs";
import {Title} from "./title.mjs";
import {Pipe} from "./pipe.mjs";
import {Audio} from "./audio.mjs";
import {TableColumn} from "./tableColumn.mjs";
import {TableRow} from "./tableRow.mjs";

const writingPractice = new WritingPractice();

const color = new Color();
const audio = new Audio();
const title = new Title();
const emphasis = new Emphasis();
const hiddenInput = new HiddenInput();
const lineFeed = new LineFeed();
const pipe = new Pipe();
const text = new Text();
const tableColumn = new TableColumn();
const tableRow = new TableRow();
const table = new Table();

const lectureRules = Object.freeze([
    writingPractice,
    color,
    audio,
    title,
    emphasis,
    hiddenInput,
    tableColumn,
    tableRow,
    table,
    lineFeed,
    pipe,
    text
]);

const specialRules = Object.freeze([
    color,
    audio
]);

const nodeNameToRule = Object.freeze({
    WRITING_PRACTICE: writingPractice,
    TABLE: table,
    TEXT: text,
    LINE_FEED: lineFeed,
    TITLE_1: title,
    TITLE_2: title,
    TITLE_3: title,
    EMPHASIS_BOLD: emphasis,
    EMPHASIS_ITALIC: emphasis,
    EMPHASIS_BOLD_ITALIC: emphasis,
    HIDDEN_INPUT: hiddenInput,
    COLOR: color,
    AUDIO: audio,
    TABLE_ROW: tableRow,
    TABLE_HEADER: tableRow,
    TABLE_COLUMN: tableColumn,
    PIPE: pipe,
});

export {lectureRules, nodeNameToRule}

